import { cn } from "../lib/utils.ts";

/** 肛了么 brand mark — same geometry as the desktop app icon. */
export function BrandMark(props: { className?: string; title?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="none"
      className={cn("size-7 shrink-0", props.className)}
      role="img"
      aria-label={props.title ?? "肛了么"}
    >
      <title>{props.title ?? "肛了么"}</title>
      <rect width="1024" height="1024" rx="229" ry="229" fill="#1A1A1A" />
      <path
        d="M278 146C278 119.49 299.49 98 326 98H384C410.51 98 432 119.49 432 146V878C432 904.51 410.51 926 384 926H326C299.49 926 278 904.51 278 878V146Z"
        fill="#F5A623"
      />
      <path
        d="M408.45 514.71C386.846 497.312 383.438 465.713 400.836 444.11L667.76 112.7C685.157 91.096 716.756 87.688 738.36 105.086L783.55 141.47C805.154 158.868 808.562 190.466 791.164 212.07L524.24 543.48C506.843 565.084 475.244 568.492 453.64 551.094L408.45 514.71Z"
        fill="#F5A623"
      />
      <path
        d="M401.793 585.227C381.694 566.098 380.908 534.295 400.037 514.196L440.033 472.177C459.162 452.078 490.965 451.292 511.064 470.421L814.207 758.773C834.306 777.902 835.092 809.705 815.963 829.804L775.967 871.823C756.838 891.922 725.035 892.708 704.936 873.579L401.793 585.227Z"
        fill="#F5A623"
      />
    </svg>
  );
}
